import React from 'react'
import { cn } from 'utils/cn'

export interface SpinnerProps {
    color?: 'accent' | 'default' | 'current' | 'success' | 'warning' | 'danger'
    size?: number
    style?: React.CSSProperties
}

const colorMap: Record<string, string> = {
    accent: 'text-accent',
    default: 'text-foreground',
    current: 'text-current',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
}

export const Spinner = ({ color = 'accent', size = 24, style }: SpinnerProps) => {
    const trackOpacity = color === 'current' || color === 'default' ? 0.2 : 0.15
    const strokeWidth = 3

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            role="status"
            aria-label="Loading"
            className={cn('shrink-0 animate-[spin_0.8s_linear_infinite]', colorMap[color])}
            style={style}
        >
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={strokeWidth} opacity={trackOpacity} />
            <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
    )
}
